export default "__VITE_ASSET__4irrTmaC__"